import { SelectPicker as SelectPickerRsuite } from 'rsuite';

type Placement =
  | 'bottomStart'
  | 'bottomEnd'
  | 'topStart'
  | 'topEnd'
  | 'leftStart'
  | 'leftEnd'
  | 'rightStart'
  | 'rightEnd'
  | 'auto'
  | 'autoVerticalStart'
  | 'autoVerticalEnd'
  | 'autoHorizontalStart'
  | 'autoHorizontalEnd';

export type SelectPickerProps = {
  data: any;
  searchable?: boolean;
  style?: any;
  onChange: any;
  defaultValue?: any;
  placeholder?: string;
  placement?: Placement;
  className?: string;
};

export const SelectPicker = ({
  data,
  searchable = false,
  style,
  onChange,
  defaultValue,
  placeholder,
  placement,
  className = '',
}: SelectPickerProps) => {
  return (
    <SelectPickerRsuite
      data={data}
      searchable={searchable}
      style={style}
      onChange={onChange}
      defaultValue={defaultValue}
      placeholder={placeholder}
      placement={placement}
      className={className}
    />
  );
};
